module.exports = __webpack_public_path__ + "static/img/goufang.ed281062.png";